import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menus: []
  },
  mutations: {
    SET_MENUS(state, menus) {
      state.menus = menus
    }
  },
  actions: {
    setMenus({ commit }, menus) {
      commit('SET_MENUS', menus)
    }
  }
})
